// Project source previews use the Mac's selected-folder connection.
const noReference = () => null;
export default function useProjectSourceReference() { return noReference; }
